/**
 * Clinical collaboration-note domain types shared by pages, hooks, and views.
 *
 * API DTOs remain in `api/clinicalTrialsApiTypes.ts`; these types describe the
 * structured rich text and filter state owned by the dashboard.
 */

/** Inline text marks supported by the safe notes editor and renderer. */
export type RichTextMark = "bold" | "italic" | "underline";

/** One text span in a structured rich-text block. */
export interface RichTextSpan {
  text: string;
  marks?: RichTextMark[];
}

/** A paragraph or list item in a note or reply body. */
export interface RichTextBlock {
  type: "paragraph" | "bullet_list_item" | "ordered_list_item";
  content: RichTextSpan[];
}

/** Versioned, JSON-only rich text accepted by the notes API. */
export interface RichTextDocument {
  schema_version: 1;
  content: {
    blocks: RichTextBlock[];
  };
  plain_text: string;
}

/** Facility inbox filters represented by the `/notes` query string. */
export interface NotesFilters {
  query: string;
  unreadOnly: boolean;
  assignedToMe: boolean;
  assigneeId: string;
  overdueOnly: boolean;
  status: "all" | "open" | "resolved";
  orderBy: "created_at" | "updated_at" | "due_date";
  orderDirection: "asc" | "desc";
}

/** Default facility inbox state: newest-created notes first. */
export const DEFAULT_NOTES_FILTERS: NotesFilters = {
  query: "",
  unreadOnly: false,
  assignedToMe: false,
  assigneeId: "",
  overdueOnly: false,
  status: "all",
  orderBy: "created_at",
  orderDirection: "desc",
};
